<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="mb-1">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link :to="'/'">Home</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">Care logs</li>
            </ol>
          </nav>
        </div>
        <div v-for="log in entries" :key="log._id">
          <!-- TEXT ENTRY -->
          <div class="card mb-3" v-if="log.entryType === 'note'">
            <h6 class="card-header">
              <span>📝 Care log</span>
            </h6>
            <div class="card-body">
              <p v-if="log?.tags?.length">
                <span class="text-muted">Tags: </span>
                <strong>{{ log.tags.join(', ') }}</strong>
              </p>
              <p>
                {{ log.text }}
              </p>
            </div>
            <div class="card-footer">
              <div class="d-flex flex-row">
                <span class="me-auto">
                  <b-icon icon="person"></b-icon>&nbsp;
                  <strong>{{ log.authorName }}</strong>
                </span>
                <span>{{ log.createdAt | moment("from", "now") }}</span>
              </div>
            </div>
          </div>
          <!-- URINE OUTPUT -->
          <div class="card px-3 py-1 mb-3" v-if="log.entryType === 'urine-output'">
            <span><strong>🚽 Urine output: </strong>{{ log.text }}</span>
            <div class="d-flex flex-row small-footer">
              <span class="me-auto">
                <b-icon icon="person"></b-icon>&nbsp;
                {{ log.authorName }}
              </span>
              <span>{{ log.createdAt | moment("from", "now") }}</span>
            </div>
          </div>
          <!-- BOWEL MOVEMENT -->
          <div class="card px-3 py-1 mb-3" v-if="log.entryType === 'bowel-movement'">
            <span><strong>💩 Bowel movement: </strong>{{ log.text }}</span>
            <div class="d-flex flex-row small-footer">
              <span class="me-auto">
                <b-icon icon="person"></b-icon>&nbsp;
                {{ log.authorName }}
              </span>
              <span>{{ log.createdAt | moment("from", "now") }}</span>
            </div>
          </div>
        </div>
        
        <!-- Load More Button -->
        <div v-if="pagination.hasMore" class="text-center mt-4">
          <button 
            @click="loadMore" 
            class="btn btn-outline-primary"
            :disabled="loading"
          >
            <span v-if="loading">Loading...</span>
            <span v-else>Load More ({{ pagination.total - (pagination.offset + pagination.limit) }} remaining)</span>
          </button>
        </div>
        
        <!-- No more data message -->
        <div v-else-if="entries.length > 0" class="text-center mt-4 text-muted">
          <small>All {{ pagination.total }} care logs loaded</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';

export default {
  name: 'Log',
  components: {
  },
  data: () => ({
    entries: [],
    pagination: {
      limit: 20,
      offset: 0,
      total: 0,
      hasMore: false
    },
    loading: false,
  }),
  async mounted() {
    this.loadCareLogs();
  },
  methods: {
    async loadCareLogs(reset = true) {
      this.loading = true;
      
      try {
        const params = {
          limit: this.pagination.limit,
          offset: reset ? 0 : this.pagination.offset
        };
        
        const { data } = await this.$api.get('/care-logs', { params });
        
        if (reset) {
          this.entries = data.data;
          this.pagination = data.pagination;
        } else {
          this.entries = [...this.entries, ...data.data];
          this.pagination = data.pagination;
        }
      } catch (error) {
        console.error('Error loading care logs:', error);
      } finally {
        this.loading = false;
      }
    },
    async loadMore() {
      this.pagination.offset = this.entries.length;
      await this.loadCareLogs(false);
    },
  },
}
</script>

<style scoped>
.card-body {
  white-space: pre-line;
}

.small-footer {
  font-size: 0.75em;
}
</style>